import React, { useEffect } from 'react';
import { useLocation, Link } from 'react-router-dom';
import Footer from './Footer';
import NavBar from './Navbar/NavBar';
import CommonContainer from './CommonContainer';

function Layout({ children }) {
  const location = useLocation();
  const pathSegments = location.pathname.split('/').filter(Boolean);

  // route segment -> friendly breadcrumb label
  const breadcrumbLabels = {
    changepassword: 'Change Password',
    contactverify: 'Contact Verify',
    forgotpassword: 'Forgot Password',
    emailverify: 'Email Verify',
  };

  // UUID / long-token look-alike segments should not show in breadcrumb
  const isTokenSegment = (segment) =>
    /^[0-9a-fA-F-]{15,}$/.test(segment) || segment.length > 20;

  // Scroll to top on route change
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  return (
   <div className="min-h-screen flex flex-col">
      {/* Header */}
      <NavBar />

      {/* Breadcrumb Navigation */}
      {location.pathname !== '/' && (
  <CommonContainer>
   <div className="flex justify-end items-center w-full py-4 text-lg font-semibold text-[#013289] mt-16">
      <Link to="/" className="text-blue-900 hover:text-blue-500">
        Home
      </Link>

     {pathSegments
  .filter((segment) => !isTokenSegment(segment))
  .map((segment, index, filteredSegments) => {
    const label = breadcrumbLabels[segment.toLowerCase()] || segment;

    return (
      <React.Fragment key={index}>
        <span className="mx-2">/</span>
        <span className="text-blue-900 capitalize">
          {label}
        </span>
      </React.Fragment>
    );
  })}
    </div>
  </CommonContainer>
)}

      {/* Main Content */}
      {/* Main Content */}
<main className="flex-1">
  {children}
</main>

      {/* Footer */}
    {/* Footer */}
<Footer />
    </div>
  );
}

export default Layout;
